const modules = import.meta.glob("./*PersonalInfo.js", { eager: true });

const mapModuleCodeAndPersonalInfo = {
    CM: "CrimePersonalInfo",
    FM: "FamilyPersonalInfo",
    IM: "ImmigrationPersonalInfo",
    IJ: "InjuryPersonalInfo",
    TX: "TaxesPersonalInfo",
};

export const getEventFields = (moduleCode) => {
    const pInfoName = moduleCode && mapModuleCodeAndPersonalInfo[moduleCode];
    const PersonalInfoJS = pInfoName && modules[`./${pInfoName}.js`];
    if (!PersonalInfoJS) {
        return [];
    }

    if (!PersonalInfoJS.getEventFields) {
        return [];
    }

    if (typeof PersonalInfoJS.getEventFields === "function") {
        return PersonalInfoJS.getEventFields();
    }

    return [];
};
